var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 3.53516L25.293 21.7188L18.3594 23.8281L32.1875 3.53516ZM35.625 24.1797C36.2109 23.4375 35.9961 22.4609 35.332 22.0117L25 23.2422L14.1992 27.2852C14.4141 27.7734 14.9023 28.1445 15.5469 28.1445H24.707L24.8047 32.8125L17.7539 46.4844L35.625 24.1797Z",
    fill: "#431E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 46.4844L24.707 28.1445H28.5352L17.7539 46.4844Z",
    fill: "url(#paint0_linear_2460_2308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 25.8008C14.043 26.2695 14.0039 26.8359 14.1992 27.2852L35.3125 21.9922C35.0586 21.8164 34.7656 21.7188 34.4141 21.7188H21.3281L32.168 3.53516L14.4141 25.8008Z",
    fill: "url(#paint1_linear_2460_2308)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2308",
    x1: 14.9076,
    y1: 43.6377,
    x2: 29.4613,
    y2: 29.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6BC7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8EFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2460_2308",
    x1: 16.7195,
    y1: 29.8057,
    x2: 37.5854,
    y2: 8.93965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#6BC7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#4DA0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#3A88FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#4634B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4B0D91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.c570f2bc6779285a5023cf78e0afd97e.svg";
export { ForwardRef as ReactComponent };